import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=93962c2a&scoped=true&"
var script = {}
import style0 from "./Group.vue?vue&type=style&index=0&id=93962c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93962c2a",
  null
  
)

export default component.exports